define.alias("ember-composable-helpers/helpers/map", "calendar/helpers/map");